import { render } from "./PayMix.vue?vue&type=template&id=1bef5455&scoped=true"
import script from "./PayMix.vue?vue&type=script&lang=js"
export * from "./PayMix.vue?vue&type=script&lang=js"

import "./PayMix.vue?vue&type=style&index=0&id=1bef5455&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bef5455"]])

export default __exports__